export const API_ENDPOINTS = {
	// META
	GET_META: 'v1/metadata',
	GET_COUNTRY_DROPDOWN_LIST: 'v1/countries-dropdown-list',
	CREATE_ORDER: 'v1/marketplace/create-order',
}
